import Image, { ImageProps } from "next/image";

const LocalImage = ({ src, ...props }: ImageProps) => (
  // eslint-disable-next-line react/forbid-elements
  <Image src={src} unoptimized {...props} />
);

export default LocalImage;
